import {useSelector} from 'react-redux'
import {
  getAppLockedDealConfig,
  getOfferAccessFlowSettings,
  getOfferHasGhaOrGvrPreferredRate,
  getShowTotalPrices,
  getShowTotalPriceToggle
} from 'modules/sapiSearch/selectors'
import {SearchOffer} from 'modules/sapiSearch/slice'
import {getIsLockedDealExcludingGHA} from 'modules/search/selectors'
import {toggle} from 'opticks'

export const useShowTotalPriceGhaOrGvrPreferredRate = (
  offer: SearchOffer,
  hotelId: string,
  // remove this prop on B side of 7d6464d8-move-auth-to-ap
  isRequiredOneTimePasswordFlow: boolean
) => {
  const isLockedDeal = useSelector(getIsLockedDealExcludingGHA(offer, hotelId))
  const showTotalPrices = useSelector(getShowTotalPrices)
  const showTotalPriceToggle = useSelector(getShowTotalPriceToggle)

  const {isAppLockedDeal} = useSelector(state =>
    getAppLockedDealConfig(state, hotelId, offer?.id)
  )
  // Added as part of 7d6464d8-move-auth-to-ap
  const {isSpecial} = useSelector(state =>
    getOfferAccessFlowSettings(state, hotelId, offer?.id)
  )

  const shouldShowTotalPrice = toggle(
    '7d6464d8-move-auth-to-ap',
    isLockedDeal || isAppLockedDeal || isRequiredOneTimePasswordFlow,
    isSpecial
  )

  const offerHasGhaOrGvrPreferredRate = useSelector(state =>
    getOfferHasGhaOrGvrPreferredRate(state, offer)
  )

  return (
    shouldShowTotalPrice &&
    offerHasGhaOrGvrPreferredRate &&
    !showTotalPrices &&
    showTotalPriceToggle
  )
}
